import React from 'react';

/**
 * Skip Navigation Link
 * Provides keyboard users a way to bypass repetitive navigation
 * WCAG 2.4.1 Bypass Blocks (Level A)
 */
const SkipNav = () => {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-sky-600 focus:text-white focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-sky-400"
    >
      Skip to main content
    </a>
  );
};

export default SkipNav;
